import { RegistrationStatus, VerifyResponse } from './SuccessStage'
import { Button, Card, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import SuccessRegistrationCard from './SuccessRegistrationCard'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { resetAll } from '../../store/actions'
import React, { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useMediaQuery } from 'react-responsive'
import { isMobileQuery } from '../../utils'
import { DistributionType } from '../../store/program/interfaces'
import { useNavigate } from 'react-router-dom'
import * as routes from '../../routes'


const SuccessBody = (props: { resp: VerifyResponse }) => {
  const { resp } = props
  const { baseUrl } = useSelector((state: RootState) => state.misc,)
  const { data: program } = useSelector((state: RootState) => state.program)
  const dispatch = useDispatch()
  const { data: institution } = useSelector((state: RootState) => state.institution,)
  const { loadedViaCode } = useSelector((state: RootState) => state.misc)
  const isMobile = useMediaQuery(isMobileQuery)
  const navigate = useNavigate()

  useEffect(() => {
    // Update the document title using the browser API
    document.title = `${program.name}: Abschluss | Feripro ${institution.name}`
  })
  return (
    <>
      <Card>
        <Card.Body>
          {resp.submitted ? (
            <>
              <Card.Title>
                <h2>Anmeldung übermittelt</h2>
              </Card.Title>
              <Card.Text>
                {program.distribution_type === DistributionType.INSTANT &&
                  <p>Die Anmeldungen wurden direkt zugeteilt.</p>
                }
                {program.distribution_type === DistributionType.DEADLINE &&
                  <p>Die Anmeldungen werden später von der Institution zugeteilt.</p>
                }
                {resp.submitted &&
                  (loadedViaCode ? (
                    <p>
                      Bitte überprüfen Sie nun Ihren Veranstaltungspass, die neu
                      hinzugebuchten Anmeldungen sollten dort erscheinen.
                    </p>
                  ) : (
                    <p>
                      Eine E-Mail mit weiteren Informationen wurde an die angegebene Adresse gesendet.
                      Bitte prüfen Sie auch Ihren Spam-Ordner, falls Sie keine Nachricht erhalten haben.                      {' '}
                    </p>
                  ))}

              </Card.Text>
            </>
          ) : (
            <>
              <Card.Title>
                <h2>Fehler beim Speichern der Anmeldung</h2>
              </Card.Title>
              <Card.Text dangerouslySetInnerHTML={{ __html: resp.message }} />
              <Button className={"mobile-btn"} onClick={() => navigate(routes.PARTICIPANT.path)}>
                Daten bearbeiten
              </Button>
            </>
          )}
        </Card.Body>
      </Card>
      {resp.info.registration_states &&
        Object.values(RegistrationStatus)
          .filter(status => !!resp.info.registration_states?.[status])
          .map((status, key) => (
            <SuccessRegistrationCard
              type={status}
              registrations={resp.info.registration_states![status]}
              key={key}
            />
          ))}
      { resp.submitted && <Card>
        <Card.Body>
          <Row>
            <Col className="d-flex flex-column flex-md-row flex-wrap justify-content-between gap-2 gap-md-3">
              {
                program.distribution_type === 'INSTANT' ?
                  (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-next">Auf dem Veranstaltungspass sehen Sie ihre Anmeldedaten.</Tooltip>}
                    >
                      <Button
                        className={isMobile ? 'w-100 mb-2' : ' mb-2'}
                        onClick={()=> window.open(`${baseUrl}${resp.pass_url}`, '_blank')}>
                        <FontAwesomeIcon icon='address-card' style={{ marginRight: '0.5rem' }} />
                        Veranstaltungspass
                        { program.payment_configuration.online.enabled && resp.info.registration_states?.['1_YES'] &&
                          <>
                          {" und "}
                            <FontAwesomeIcon icon='euro-sign'/> Bezahlung
                          </>
                        }
                      </Button>
                    </OverlayTrigger>
                  ) : <></>}
              {!program.requires_family_data ? (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-next">Startet den Anmeldeprozess für ein weiteres Familienmitglied mit bereits vorausgefüllten Daten.</Tooltip>}
                >
                  <Button
                    variant={"outline-primary"}
                    className={isMobile ? 'w-100 mb-2' : ' mb-2'}
                    onClick={async () =>  {
                      const route = `${baseUrl}/anmeldung/${program.id}/?family_token=${resp.info.uuid}`
                      //need to replace port for dev testing, should work on prod
                      // @ts-ignore
                      if (window._is_react_dev_server) {
                        window.location.replace(route.replace('8000', '3000'))
                      } else {
                        window.location.replace(route)
                      }
                    }}>
                    <FontAwesomeIcon icon='add' style={{ marginRight: '0.5rem' }} />
                    Familienmitglied hinzufügen
                  </Button>
                </OverlayTrigger>
              ) :<></>}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-next">Startet den Anmeldeprozess von vorne.</Tooltip>}
              >
                <Button
                  variant={"outline-primary"}
                  className={isMobile ? 'w-100 mb-2' : ' mb-2'}
                  onClick={async () =>  {
                    dispatch(resetAll())
                    window.location.reload()
                  }}>
                  <FontAwesomeIcon icon='repeat' style={{ marginRight: '0.5rem' }} />
                  Neu starten
                </Button>
              </OverlayTrigger>

            </Col>

          </Row>
        </Card.Body>
      </Card>
      }
    </>
  )
}

export default SuccessBody
